/**
 * @file: ExceptionBufferTime.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 异常缓冲时间
 */
import request from '@/utils/request'

/**
 * 异常缓冲时间-批量删除（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionBufferTimeDelete(data) {
  return request({
    type: 'device',
    url: 'exception/buffer/time/delete',
    method: 'post',
    data
  })
}

/**
 * 异常缓冲时间-获取信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionBufferTimeGet(data) {
  return request({
    type: 'device',
    url: 'exception/buffer/time/get',
    method: 'post',
    data
  })
}

/**
 * 异常缓冲时间-新增（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionBufferTimeInsert(data) {
  return request({
    type: 'device',
    url: 'exception/buffer/time/insert',
    method: 'post',
    data
  })
}

/**
 * 异常缓冲时间-获取分页列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionBufferTimeList(data) {
  return request({
    type: 'device',
    url: 'exception/buffer/time/list',
    method: 'post',
    data
  })
}

/**
 * 异常缓冲时间-更新（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionBufferTimeUpdate(data) {
  return request({
    type: 'device',
    url: 'exception/buffer/time/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/ExceptionBufferTime.js